import { render, staticRenderFns } from "./GridViewAs.vue?vue&type=template&id=2b13b95c&"
import script from "./GridViewAs.vue?vue&type=script&lang=js&"
export * from "./GridViewAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports